import { FormattedMessage } from '@flipster/i18n';
import { IsomorphicLink } from '@flipster/react/design-utils/isomorphic-link';
import { css } from '@flipster/styled-system/css';

// 구 약관 효력이 사라진 이후에 contentful로 대체될 예정
export const PremiumEarnTerms = () => {
  return (
    <div
      className={css({
        textStyle: 'Text/M/Regular',
        color: 'content.default.level-2',
        '& h3': {
          textStyle: 'Text/L/Strong',
          color: 'content.default.level-5',
          mb: 16,
        },
        '& strong, h4': {
          textStyle: 'Text/M/Strong',
        },
        '& h4, p, ul': {
          my: 16,
        },
        '& li': {
          listStyle: 'disc',
          ml: 24,
        },
      })}
    >
      {/* [New Premium Earn Terms] */}
      <div>
        <p>
          These Premium Earn Terms (“<b>PE Terms</b>”) shall govern participation in Flipster’s Premium Earn product
          made available by Flipster on the Trading Platform (“<b>Premium Earn</b>”). Your participation in Premium Earn
          shall constitute your agreement to the PE Terms.
        </p>
        <p>
          All capitalised terms and references used in these PE Terms that are defined and construed in the Flipster
          Terms of Use (the “<b>Terms of Use</b>”) but are not defined or construed in these PE Terms shall have the
          same meaning and construction in these PE Terms as in the Terms of Use. For the avoidance of doubt, where a
          term is defined both in the Terms of Use and in these PE Terms, the definition provided in these PE Terms
          shall (for the purposes of Premium Earn only) apply.
        </p>
        <p>
          The PE Terms shall be supplemental to and are to be read together with the Terms of Use, Derivatives Trading
          Rules and the Policies (where relevant). In the event of any conflict or inconsistency between the terms
          herein and the Terms of Use or the Derivatives Trading Rules or the Policies, as the case may be, the terms
          herein shall prevail with respect to the products contemplated hereunder unless expressly stated otherwise.
        </p>
        <p>
          Unless otherwise expressly agreed by us in writing, this version of these PE Terms shall replace and supersede
          all previous versions of these PE Terms that may have been accepted by you or otherwise made available on the
          Trading Platform.
        </p>
        <p>
          These PE Terms are binding between you and Flipster Corp (“<b>we</b>”, “<b>us</b>” or “<b>our</b>”), a company
          incorporated under the laws of the Republic of Panama.
        </p>
        <p>Premium Earn is not available to users from Prohibited Jurisdictions.</p>
        <p>
          Premium Earn is a platform product under which eligible users participate by subscribing for Premium Earn USDT
          using USDT. Upon such subscription, users hold Premium Earn USDT and participate in Premium Earn subject to
          these PE Terms. Except as expressly stated otherwise, references in these PE Terms to participation in Premium
          Earn refer to the subscription for, holding of, and redemption of Premium Earn USDT.
        </p>
        <p>
          <b>Definitions and Interpretation</b>
        </p>
        <p>1.1. The following definitions are applicable to these Premium Earn:</p>
        <ul>
          <li>
            <p>
              “<b>Applicable Law</b>” means any law, statute, bye-law, regulation, order, regulatory policy, guidance or
              industry code or practice, rule of court or directives or requirements of any governmental or regulatory
              authority, or any delegated or subordinated legislation or notice, each as amended and promulgated from
              time to time, that may be directly or indirectly related to or implicated by the relevant activities or
              transactions carried out or otherwise arising under Premium Earn.
            </p>
          </li>
          <li>
            <p>
              <b>Derivatives Trading Rules</b>” shall have the same meaning as set out in the Trading Platform's{' '}
              <IsomorphicLink
                href='https://flipster.io/en/policies/derivatives'
                newTab
                className={css({
                  textStyle: 'Text/M/Regular',
                  color: 'content.default.level-2',
                  textDecoration: 'underline',
                  px: 6,
                })}
              >
                Derivatives Trading Terms;
              </IsomorphicLink>
              ;
            </p>
          </li>
          <li>
            <p>
              “<b>Loss</b>” means any and all losses, damages, costs, charges and/or expenses, including, but not
              limited to, legal fees on a full indemnity basis, cost of funding, losses or costs incurred as a result of
              the terminating, liquidating or re-establishing of any hedge or related trading position, loss of profit,
              loss of revenue, loss of opportunity, consequential, unforeseeable, special or indirect damages or
              expenses.
            </p>
          </li>
          <li>
            <p>
              “<b>Redemption Period</b>” shall have the meaning as set out in Clause 8.1.
            </p>
          </li>
        </ul>
        <p>
          1.2. The headings of each provision in these PE Terms are inserted for convenience only and shall not affect
          the construction of these PE Terms. Expressions in the singular form shall include the plural and vice versa,
          and all references to the masculine genders shall include the female and neuter genders and vice versa.
        </p>
        <p>
          1.3. The words “include” or “including” shall be deemed to be followed by “without limitation” or “but not
          limited to” whether or not they are followed by such phrases or words of like import, and “otherwise” shall
          not be construed as limited by words with which it is associated.
        </p>
        <p>
          <b>2. General</b>
        </p>
        <p>
          2.1. By participating in Premium Earn, you agree to be bound by (i) these PE Terms; (ii) the Terms of Use; and
          (iii) the Derivatives Trading Rules (where relevant); (iv) the Policies; and (v) any other rules that apply in
          relation to Premium Earn provided by us from time to time, which shall include, without limitation, any
          applicable Guides (as defined in the Terms of Use), terms of service, and/or protocols that we determine at
          our discretion to form part of these PE Terms in our sole and absolute discretion (as available here or on
          such other webpage as notified by us from time to time) (collectively, the “<b>PE Rules</b>”).
        </p>
        <p>2.2. We may, from time to time, amend the PE Terms or the PE Rules in our sole discretion.</p>
        <p>
          2.3. Nothing in these PE Terms or on our Trading Platform or otherwise obliges us to provide Premium Earn and
          its related information, rewards, features, or functions to you and we may at any time change, suspend,
          terminate, restrict or discontinue provision of Premium Earn, or any information, rewards, features or
          functions available through the Trading Platform either temporarily or on a permanent basis, in each case, at
          any time in our sole and absolute discretion, without providing any reason or any Notice to you thereof.
        </p>
        <p>
          2.4. Nothing contained on the Trading Platform is to be construed as an offer, an invitation to offer or a
          recommendation to enter into any transaction (including to participate in Premium Earn in any way) which can
          be accepted by you to create contractual obligations without further action by us. You acknowledge that no
          advice is provided by us to you with respect to your use of the Trading Platform (including, without
          limitation, advice relating to the execution of any transaction, or any legal, tax or accounting advice
          regarding the suitability or profitability of any security, investment or transaction). You also acknowledge
          that the Trading Platform provides you with information which is general in nature, and that such information
          shall not be construed as financial advice from us to you, or as an offer, solicitation or recommendation of
          securities or other financial products from us to you. Such information is not personalized or in any way
          tailored to reflect your particular investment objectives, financial situation or needs. You acknowledge that
          any transaction(s), features(s), product(s), service(s) or function(s) available on the Trading Platform may
          not be appropriate for all investors and that you should take steps to ensure that, before entering into any
          transaction, you fully understand the transaction and have made an independent assessment (and/or have sought
          third party advice from your own advisors) of the appropriateness of the transaction(s) in light of your own
          objectives and circumstances (including the possible risks and benefits of entering into such Transaction). If
          you decide to enter into any transaction, you shall do so in reliance on your own judgement.
        </p>
        <p>
          2.5. You acknowledge that there are legal requirements in various countries which may restrict the products
          and services that we can lawfully provide to you. Accordingly, some products, services, features, and
          functionality within the Trading Platform, including in relation to Premium Earn, may not be available or may
          be restricted in certain jurisdictions or regions or to certain users. You shall be responsible for
          understanding and observing any restrictions and/or requirements imposed with respect to the access to and use
          of Premium Earn in each jurisdiction from which the Trading Platform is accessed by you or on your behalf. We
          reserve the right to change, modify or impose additional restrictions with respect to the access to and use of
          the Trading Platform and Premium Earn from time to time in our sole discretion without Notice.
        </p>
        <p>
          <b>3. Eligibility</b>
        </p>
        <p>
          3.1. Participation in Premium Earn is strictly conditional upon users having successfully completed all
          identity verification, know-your-customer, anti-money laundering, and sanctions screening procedures required
          by us from time to time.
        </p>
        <p>
          3.2. Access to Premium Earn is subject to applicable laws, regulations, regulatory guidance, and internal risk
          assessments. Premium Earn is not available in all jurisdictions and may be restricted or unavailable to
          certain users, accounts or regions.
        </p>
        <p>
          3.3. Employees, officers, contractors, affiliates, and any other categories of persons designated by Flipster
          may be excluded from participation.
        </p>
        <p>
          3.4. We may, in our sole and absolute discretion, refuse, suspend, restrict, or revoke access to Premium Earn
          at any time, without notice and without liability, including where continued access presents legal,
          regulatory, operational, or regulatory risk.
        </p>
        <p>
          <b>4. Product Definition and Scope</b>
        </p>
        <p>
          4.1. Premium Earn is a discretionary platform product under which eligible users participate by subscribing
          for and holding Premium Earn USDT which may provide access to certain utilities made available by Flipster
          from time to time. Such utilities may include, but are not limited to, the ability to receive discretionary
          rewards.
        </p>
        <p>4.2. Premium Earn USDT is not:</p>
        <p>(i) a bank account, deposit, or savings product;</p>
        <p>(ii) insured or guaranteed by any government authority;</p>
        <p>(iii) capital-protected;</p>
        <p>(iv) a promise or obligation to pay an interest or return; or</p>
        <p>(v) a promise or obligation to return assets on demand.</p>
        <p>
          4.3. Participation in Premium Earn does not create any fiduciary, trust, advisory, partnership, or agency
          relation between users and Flipster.
        </p>
        <p>
          4.4. No information made available in connection with Premium Earn constitutes investment advice,
          recommendation, offer, or solicitation. You acknowledge that you do not rely on information provided by us in
          deciding to participate in Premium Earn.
        </p>
        <p>
          <b>5. Purchase of Premium Earn USDT</b>
        </p>
        <p>
          5.1.Participation in Premium Earn requires the purchase of Premium Earn USDT using USDT through the Trading
          Platform. By submitting a request to purchase Premium Earn USDT, you instruct us to exchange the corresponding
          amount of USDT for Premium Earn USDT at a 1:1 ratio, subject to these PE Terms.
        </p>
        <p>
          5.2. Upon completion of a purchase of Premium Earn USDT, the USDT used for such purchase becomes the property
          of Flipster, and you cease to have ownership, proprietary, or security interest in such USDT.
        </p>
        <p>
          5.3. Premium Earn USDT is a non-transferable on-platform asset that is issued by us in connection with Premium
          Earn. Premium Earn USDT is not issued on any blockchain and exists solely within our internal systems. It is
          not legal tender, e-money, a stablecoin, a security, a derivative, or any other regulated financial
          instrument, and does not represent a claim against any segregated pool of assets.
        </p>
        <p>
          5.4. Premium Earn USDT may only be held within your Account on the Trading Platform and cannot be transferred,
          withdrawn, or used outside the Trading Platform. It cannot be transferred to Account(s) belonging to other
          users within the Trading Platform.
        </p>
        <p>
          5.5. We have the right to implement any limits or restrictions on the amount of Premium Earn USDT that users
          may subscribe for (whether to specific users or in aggregate to all users), or any other transaction limits
          from time-to-time at our sole discretion. We may implement such limits or restrictions directly through the
          Trading Platform, without prior notice to you.
        </p>
        <p>
          5.6. We reserve the right to temporarily or permanently cease the offering of Premium Earn USDT whether to you
          or to all users or any group of users, as we determine in our sole and absolute discretion.
        </p>
        <p>
          5.7. We may issue, deduct, or cancel Premium Earn USDT in accordance with these PE Terms, including in
          connection with redemption, trading activity, fees, losses, liquidations, or risk management measures.
        </p>
        <p>
          5.8. All records relating to Premium Earn USDT maintained by our systems are final and binding, absent
          manifest error.
        </p>
        <p>
          <b>6. Use of Premium Earn USDT, and Risk Allocation</b>
        </p>
        <p>
          6.1. Your Premium Earn USDT may be used as margin for trading of certain Derivatives trading pairs on the
          Trading Platform, as made available on the Trading Platform from time to time at our sole discretion subject
          always to the Derivatives Trading Rules.
        </p>
        <p>
          6.2. We may suspend, modify, or withdraw any features, uses, or utilities associated with Premium Earn USDT at
          any time without prior notice.
        </p>
        <p>6.3. Users bear all risks associated with participation in Premium Earn, including, without limitation:</p>
        <p>(i) insolvency;</p>
        <p>(ii) loss of principal;</p>
        <p>(iii) market volatility;</p>
        <p>(iv) counterparty default;</p>
        <p>(v) protocol, smart contract, oracle, or infrastructure failure;</p>
        <p>(vi) liquidity constraints or redemption delays; and</p>
        <p>(vii) regulatory or legal changes.</p>
        <p>
          6.4. In the event of losses arising from any of the circumstances set out in Clause 6.3 above, users may
          receive less than the value represented by your Premium Earn USDT, or nothing at all.
        </p>
        <p>
          6.5. Nothing in these PE Terms creates any custodial, trust, fiduciary, bailment, or agency relationship.
          Premium Earn USDT represents a contractual claim against Flipster only, subject to these PE Terms.
        </p>
        <p>
          <b>7. Rewards and Yield</b>
        </p>
        <p>
          7.1. Unless otherwise notified to you, and subject always to these PE Terms, the Premium Earn USDT which you
          hold is eligible to earn rewards at the rates and through the calculation and settlement methods as announced
          through our Trading Platform from time to time. All rewards, interest, yield, or similar benefits (“
          <b>Rewards</b>”) associated with Premium Earn are variable and are not guaranteed.
        </p>
        <p>
          7.2. Any rates, APRs, or projected figures displayed on the Trading Platform are indicative only. These may be
          based on historical or internal assumptions, and do not create contractual obligations or expectations on our
          part. Any past performance, displayed rates, or historic accruals are not indicative of future results.
        </p>
        <p>
          7.3. In connection with Premium Earn, we may, but are not obliged to, deploy, allocate, or otherwise utilise
          Digital Assets (as defined in the Derivative Trading Rules) through one or more yield sources, strategies,
          counterparties, or protocols (each a “<b>Yield Source</b>”). The selection, composition, replacement, or
          removal of any Yield Source is determined by us in our sole and absolute discretion and may change from time
          to time, with or without prior notice to you. You acknowledge and agree that no particular Yield Source is
          promised, implied, or required to be maintained, and that changes to Yield Sources do not give rise to any
          right to compensation, objection, appeal, or termination
        </p>
        <p>
          <b>8. Premium Earn Redemption</b>
        </p>
        <p>
          8.1. You may submit a request to redeem Premium Earn USDT through the Trading Platform in accordance with
          Clause 6.6 above, including any other procedures made available from time to time. Redemption requests are
          subject to a twenty-four (24) hour redemption period (“<b>Redemption Period</b>”) and any applicable controls
          or restrictions imposed by us. A redemption request constitutes your request to cancel your subscription to
          Premium Earn in respect of the relevant amount of Premium Earn USDT.
        </p>
        <p>
          8.2. Subject to these PE Terms, a valid redemption request will, following expiry of the Redemption Period,
          result in:
        </p>
        <p>(i) the deduction and cancellation of the corresponding amount of Premium Earn USDT; and</p>
        <p>
          (ii) the crediting of an equivalent amount of USDT to your Platform Wallet, at which point ownership of such
          credited USDT transfers to you.
        </p>
        <p>
          8.3. Upon submission of a valid redemption request (in accordance with Clause 8 below), the corresponding
          amount of Premium Earn USDT will be deducted and permanently cancelled. Following such deduction and subject
          to these PE Terms, we may credit an equivalent amount of USDT to your platform wallet. You acknowledge that
          redemption is not guaranteed, is not payable on demand, and may be delayed, suspended, or restricted in
          accordance with these PE Terms.
        </p>
        <p>
          8.4. We may impose limits, conditions, or restrictions on redemption requests for Premium Earn USDT, including
          minimum or maximum redemption amounts, batching, delays, or suspension, as we determine in our sole
          discretion.
        </p>
        <p>
          8.5. You acknowledge that Premium Earn USDT is not a deposit, custody arrangement, or on-demand product.
          Redemption requests may be delayed, batched, suspended, restricted, or refused where we determine, in our sole
          discretion, that such action is necessary or appropriate for liquidity management, risk management,
          operational, legal, or regulatory reasons. Please refer to Clause 8.4 below for further details.
        </p>
        <p>
          8.6. Without limiting the foregoing, we may temporarily or permanently suspend, or fully or partially restrict
          redemptions from Premium Earn USDT in the following situations:
        </p>
        <p>
          (i) where we consider that (or have reason to suspect that) you have violated these Premium Earn, our Terms of
          Use, Derivatives Trading Rules, or any other Policy;
        </p>
        <p>
          (ii) where we consider that (or have reason to suspect that) there are any issues, violations, or suspicious
          activities (including but not limited to in relation to money laundering, terrorist financing, fraud,
          sanctions, or any other criminal behaviour) relating to your Account including but not limited to in relation
          to customer due diligence, your account usage, or your transactions;
        </p>
        <p>
          (iii) where we are required to or where we deem it necessary do so to facilitate compliance with any
          Applicable Laws, or any request or order from a court or from any regulatory, governmental, tax, or law
          enforcement authority;
        </p>
        <p>
          (iv) where we are required to or where we deem it necessary to do so to protect the security, integrity, or
          reputation of our Trading Platform, us, or any of our affiliates; or
        </p>
        <p>(v) in case of any force majeure event.</p>
        <p>
          8.7. You acknowledge that redemption entitles you only to USDT corresponding to the Premium Earn USDT balance
          actually cancelled at the time of redemption. You have no entitlement to any Rewards that are pending,
          projected, estimated, uncredited, or not yet reflected in your Premium Earn USDT balance as of the applicable
          redemption time.
        </p>
        <p>
          8.8. You hereby specifically undertake that you fully understand and agree with the redemption terms for
          Premium Earn set out herein, and that we shall not be liable for any claims, losses, or damages arising
          directly or indirectly from any delay or failure in processing redemption requests in accordance with these PE
          Terms.
        </p>
        <p>
          <b>9. Determinations and System Authority</b>
        </p>
        <p>
          9.1. All calculations, records, determinations, and account balances maintained by the Trading Platform in
          relation to Premium Earn USDT are final and binding, absent manifest error.
        </p>
        <p>
          9.2. We are not required to disclose the identity of counterparties, protocols, strategies, allocation ratios,
          methodologies, or internal decision-making processes.
        </p>
        <p>
          9.3. Charts, dashboards, third-party data, or portfolio breakdowns made available on the Trading Platform are
          provided for informational purposes only and have no contractual effect.
        </p>
        <p>
          <b>10. Representations, Warranties, Consents, and Undertakings</b>
        </p>
        <p>10.1. You represent, warrant, agree and/or undertake (as applicable) that:</p>
        <p>
          (i) you have full capacity and authority, and (where relevant) you have obtained (and will maintain) and are
          in compliance with all necessary authorisations, consents, licences or approvals (whether under Applicable Law
          or otherwise) required to: (a) accept and agree to these PE Terms; (b) participate in, perform transactions,
          and utilize the Premium Earn program;
        </p>
        <p>
          (ii) you have made your own independent decision to: (a) accept these PE Terms; (b) open and maintain an
          Account; (c) participate in, perform transactions, and utilize the Premium Earn program; and (d) determine
          that the participation in Premium Earn is suitable or appropriate for you, based on your own judgment and/or
          advice from your advisors;
        </p>
        <p>
          (iii) you are not relying on any communication (whether written or oral) from us: (a) as investment advice;
          (b) as a recommendation to participate in Premium Earn or to enter into any transaction; or (c) as an
          assurance or guarantee of any expected results of participating in Premium Earn or any related transaction;
        </p>
        <p>
          (iv){' '}
          <b>
            you have fully read and understood these PE Terms and accept these Terms, including its conditions and
            limitations for each service, feature, or reward available to you in connection with Premium Earn
          </b>
          ;
        </p>
        <p>
          (v) you do not reside in any of the Prohibited Jurisdictions as set out in our Terms of Use, or in any other
          jurisdictions in which we have restricted the offering of Premium Earn and its related features;
        </p>
        <p>
          (vi) you are the ultimate and effective legal and beneficial owner of any Digital Assets used to subscribe for
          Premium Earn USDT, and that you will not act and are not acting as nominee, agent, or trustee for any other
          person;
        </p>
        <p>
          (vii) you are not aware of any charge, mortgage, lien, pledge, encumbrance or any other security interest over
          any part of the digital Assets used to subscribe for Premium Earn USDT;
        </p>
        <p>
          (viii) except with our express written consent, no person other than you has any interest in your Account or
          the Digital Assets used to subscribe for Premium Earn USDT within your Account;
        </p>
        <p>
          (ix) except with our express written consent, no person has or will have any security or other encumbrance
          over the Digital Assets used to subscribe for Premium Earn USDT within your Account;
        </p>
        <p>
          (x) any order placed or any other transactions or dealings with respect to Premium Earn USDT under your
          Account is solely and exclusively based on your own judgement, independent appraisal and investigation into
          the risk associated with such actions, as well as your independent determination of your actions being
          specifically suitable to you based on your own assessment of your financial resources, financial objectives
          and ability and willingness to take relevant risks;
        </p>
        <p>
          (xi) we shall not be under any duty or obligation to inquire into the purpose or propriety of any order placed
          or any other transactions or dealings with respect to Premium Earn USDT under your Account;
        </p>
        <p>
          (xii) you have complied with and shall comply with all Applicable Laws in all jurisdictions relevant to your
          Account and Premium Earn, and any transaction or other service or facility or feature provided or made
          available by us to you;
        </p>
        <p>
          (xiii) you shall not knowingly or recklessly permit the use of Premium Earn USDT, or any of our services,
          products, or features in a manner which may, in our opinion, bring us into disrepute, impair the dignity or
          degrade our good name; and
        </p>
        <p>
          (xiv) you shall not otherwise act in a manner which is substantially detrimental to our interests or the
          interests of any of our other users.
        </p>
        <p>
          10.2. The above representations, warranties, agreement and undertakings shall be deemed repeated whenever you
          place any order, take any actions, or enter into any transactions in relation to Premium Earn, and each time
          you log in to the Trading Platform.
        </p>
        <p>
          <b>11. Suspension, Modification, and Termination</b>
        </p>
        <p>11.1. We may, at any time in our sole discretion:</p>
        <p>(i) suspend or terminate Premium Earn;</p>
        <p>(ii) suspend accrual of Rewards;</p>
        <p>(iii) delay, batch, restrict, or refuse withdrawals;</p>
        <p>(iv) modify eligibility, limits, or features; or</p>
        <p>(v) impose lock-up periods or redemptions conditions.</p>
        <p>
          11.2. Such actions may be taken without prior notice and without liability, subject only to mandatory
          applicable law.
        </p>
        <p>
          <b>12. General Exclusions and our reserved rights</b>
        </p>
        <p>
          12.1. Without limiting any of our other rights and without prejudice to any other Clauses in these PE Terms,
          we shall not be liable or responsible to you, or be deemed to have defaulted under or breached these PE Terms,
          for any failure, delay, interruption, or unavailability in the provision of any of our features, functions, or
          services in relation to Premium Earn or the performance of these PE Terms, if and to the extent the foregoing
          is caused by or results from or is connected to acts beyond our reasonable control, including, without
          limitation: (a) acts of God; (b) flood, fire, earthquake, pandemic or explosion; (c) war, invasion,
          hostilities (whether war is declared or not), terrorist, hacking or cyber threats, attacks or acts, or other
          civil unrest; (d) any Fork or Vulnerability affecting the underlying software protocols governing the
          operation of USDT or to any digital currency available to you for trading on the Trading Platform from time to
          time; (e) any laws, statutes, ordinances, rules, regulations, judgments, injunctions, orders, and decrees; (f)
          action by any nation or government, any state or other political subdivision thereof, any entity exercising
          legislative, judicial or administrative functions of or pertaining to government, including, without
          limitation, any government authority, agency, department, board, commission or instrumentality, and any court,
          tribunal or arbitrator(s) of competent jurisdiction; (g) other circumstances affecting the supply of our goods
          and services; (h) any loss, shortfall, delay suspension, or failure arising from or in connection with any
          Yield Source, counterparty, protocol, smart contract, oracle, validator, liquidity venue, or internal
          allocation, rebalancing, or risk-management decision, whether or not such Yield Source or decision was
          previously disclosed.
        </p>
        <p>
          12.2. Participating in Premium Earn and the use of any platform product, service, feature or function in
          relation to Premium Earn is not suitable for everyone. You should closely examine these terms, your investment
          objectives, financial resources and risk tolerance to determine whether participating in Premium Earn is
          appropriate for you. You hereby fully acknowledge the risks associated with participating in Premium Earn,
          which includes but is not limited to the risks set out in the “Risk Disclosures” Section below.
        </p>
        <p>
          12.3. Derivatives trading is not suitable for everyone. You should examine your investment objectives,
          financial resources and risk tolerance to determine whether borrowing against your assets held with us is
          appropriate for you. You acknowledge that Derivatives trading with respect to Digital Assets is a highly
          speculative activity involving highly leveraged and rapidly fluctuating markets. You further understand and
          accept the significant risks associated with the use of margin and leverage and have determined that the use
          of margin and/or leverage is consistent with your investment objectives. Despite such risks, you acknowledge,
          understand and agree that you are willing and able to assume the financial risks and other hazards of
          Derivatives trading with respect to Digital Assets and agree that you will in no manner hold us responsible
          for Losses incurred by you under or in connection with these PE Terms, the Derivatives Trading Rules, the
          Terms of Use, Policies or otherwise. You acknowledge that trading in Derivatives involves the potential for
          profit as well as the risk of losing substantially more than your initial capital. You do not own or have any
          rights to the underlying instruments, which include Digital Assets and any rewards or yields generated from
          such Digital Assets.
        </p>
        <p>
          12.4. Notwithstanding any other provision of these PE Terms, the Derivatives Trading Rules, the Terms of Use,
          Policies, Applicable Laws or otherwise, we shall only be liable to you where a final, non-appealable judgement
          of a court of competent jurisdiction has determined that we have engaged in fraud or willful misconduct
          directly and intentionally causing your Loss. For the avoidance of doubt, negligence (whether sole,
          concurrent, or gross), errors of judgement, or commercial or risk-management decisions shall not give rise to
          liability.
        </p>
        <p>
          12.5. Notwithstanding anything in these PE Terms, we shall not be liable to you for any indirect or
          consequential Loss, or for any loss of anticipated profits or any punitive damages.
        </p>
        <p>
          12.6. To the maximum extent permitted by Applicable Laws, our total aggregate liability to you in respect of
          Premium Earn, whether in contract, tort (including negligence), misrepresentation, restitution, or otherwise,
          shall not exceed the lower of (a) the amount of fees (if any) actually paid by you to us specifically for
          Premium Earn in the six (6) months preceding the event giving rise to the claim; or (b) USD 100 (or its
          equivalent).
        </p>
        <p>
          <b>13. Assumption of Risk and No Reliance</b>
        </p>
        <p>
          13.1. To the maximum extent permitted by Applicable Laws, you expressly acknowledge, agree, and assume all
          risks arising out of or in connection with your participation in Premium Earn, whether such risks are known or
          unknown, foreseeable or unforeseeable, disclosed or undisclosed at the time of participation.
        </p>
        <p>
          13.2. You confirm that you have not relied on, and expressly disclaim reliance on, any statement,
          representation, illustration, projection, dashboard, chart, rate, APR, portfolio breakdown, yield estimate, or
          other information made available by us on the Trading Platform or otherwise, whether before or after your
          participation in Premium Earn, except as expressly set out in these PE Terms.
        </p>
        <p>
          13.3. You acknowledge that no information made available by us is intended to induce you to participate in
          Premium Earn, and that your decision to do so is based solely on your own independent assessment of risk.
        </p>
        <p>
          <b>14. Indemnity</b>
        </p>
        <p>
          14.1. You hereby agree to indemnify and hold harmless Flipster, its affiliates, and their respective officers,
          directors, and employees from any claims, losses, liabilities, or expenses arising out of:
        </p>
        <p>(i) your breach of these PE Terms, Terms of Use, Derivative Trading Rules, or the Policies;</p>
        <p>(ii) your misuse of Premium Earn; or</p>
        <p>(iii) regulatory, tax, or legal consequences attributable to your conduct.</p>
        <p>
          <b>15. Risk Disclosures (YOUR ATTENTION IS PARTICULARLY DRAWN TO THIS CLAUSE)</b>
        </p>
        <p>
          15.1. Participating in Premium Earn carries risks. Such risks include, without limitation, the risks described
          in this “Risk Disclosures” Section.
        </p>
        <p>
          15.2. By accepting the PE Terms and using any of its related services, features, or functions, you expressly
          acknowledge, accept, and assume all the risks related to its use. You should participate in Premium Earn if
          you fully understand and are willing to accept the risks. The risks set out below area not intended to be
          exhaustive and merely serves as a summary of some of the risks that you may face from participating in Premium
          Earn.
        </p>
        <p>
          15.3. <b>Risks related to restrictions on Premium Earn USDT held in Premium Earn</b>. As set out in Clause 5
          above, your Premium Earn USDT can only be held in your own Account on the Platform Wallet and cannot be
          withdrawn or transferred. Your Premium Earn USDT is also subject to a Redemption Period upon your initiation
          of a withdrawal or redemption of Premium Earn USDT. The terms relating to restrictions, rights, rewards, and
          permitted uses of Premium Earn USDT are as set out in these PE Terms, which may at any time be varied in
          accordance with Clause 16 below.
        </p>
        <p>
          15.4.{' '}
          <b>Risks related to using Premium Earn USDT as margin for Derivatives trading on the Trading Platform.</b> You
          hereby represent and confirm that you have read and accepted all the risks as set out in our Derivatives
          Trading Terms, and you hereby expressly acknowledge and accept that such risks similarly apply when you use
          Premium Earn USDT as margin for trading Derivatives on the Trading Platform.{' '}
        </p>
        <p>
          15.5. <b>Risks related to your Account and the Trading Platform</b>. You hereby represent and confirm that you
          have read and accepted all the risks as set out in our Terms of Use, and you hereby expressly acknowledge and
          accept that such risks similarly apply (with the necessary modifications) where you participate in Premium
          Earn through our Trading Platform.
        </p>
        <p>
          15.6. <b>Risks related to regulatory uncertainty</b>. The regulatory environment surrounding Digital Assets
          and the offering of this Premium Earn program and is functions and features is subject to change, and any
          adverse regulatory actions or new laws may impact the availability, operations and terms of the Premium Earn
          program, including potential disruptions, delays, or restrictions to or on redemption of USDT from the Premium
          Earn USDT program.
        </p>
        <p>
          15.7. You acknowledge and agree that Premium Earn USDT is a high-risk product, that losses may occur rapidly
          and without warning, and that you may lose all Digital Assets utilised towards Premium Earn. You further
          acknowledge that you have no right to compensation, priority, or reimbursement in the event of any loss.
        </p>
        <p>
          <b>16. Variation to these PE Terms</b>
        </p>
        <p>
          Clause 38 of the Terms of Use relating to variation of terms shall apply (with any necessary modifications) to
          these PE Terms.
        </p>
        <p>
          <b>17. Applicable Laws</b>
        </p>
        <p>
          Your relationship with us, the operation of your Account and the Trading Platform, the provision of Premium
          Earn, and the implementation of any such related transactions shall be subject to Applicable Laws. We may take
          or refrain from taking any action whatsoever, and you shall comply with, and shall do all things required by
          us in order to procure or ensure compliance with all Applicable Laws. You agree that we shall not be liable to
          you as a result of any action taken to comply with any Applicable Law.
        </p>
        <p>
          <b>18. Disputes, Governing Law, and Jurisdiction</b>
        </p>
        <p>Clause 42 of the Terms of Use shall apply (with any necessary modifications) to these PE Terms.</p>
      </div>
    </div>
  );
};

export const CheckboxAgreementText = () => {
  return <FormattedMessage id='Earn.r260224.Premium_earn_terms_agreement' />;
};
